import { api } from '../../../../../services/api'

export const prazoService = {
  async buscarPrazo(quantidade) {
    try {
      const response = await api.get('/site/v2/tercerizado/busca-prazo-tercerizado', {
        params: { quantidade },
      })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar prazo:', error)
      return { prazo: 10 } // Valor padrão em caso de erro
    }
  },
}
